export default {"src":"/_next/static/media/linkedin.93c00d6c.svg","height":72,"width":72};